export const companyID = 4 // default company canada
export const defaultLocation = 1 // default bergen logistics can
export const defaultCurrency = 3 // default canadianDollar
export const currencySymbol = 'C$'